import React from "react";
import {
	useGridApiContext,
	useGridSelector,
	gridPageCountSelector,
	gridPageSelector,
	gridPageSizeSelector,
	gridRowCountSelector,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowLeftRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowRightRounded";

const CustomFooterComponent: React.FC = () => {
	const apiRef = useGridApiContext();
	const pageCount = useGridSelector(apiRef, gridPageCountSelector);
	const currentPage = useGridSelector(apiRef, gridPageSelector);
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
	const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);

	// Calculate start and end index for the current page
	const startIndex = currentPage * pageSize + 1;
	const endIndex = Math.min((currentPage + 1) * pageSize, totalRowCount);

	const handlePageChange = (
		event: React.ChangeEvent<unknown>,
		newPage: number
	) => {
		apiRef.current.setPage(newPage - 1); // setPage uses 0-indexed pages, so subtract 1 from newPage
	};

	return (
		<Box
			className="flex flex-col gap-4 p-2 md:p-5 md:flex-row justify-between items-center rounded-lg mt-3"
			sx={{
				background: "#f5f5f5",
			}}
		>
			<Typography variant="body2">
				Showing {startIndex}-{endIndex} from {totalRowCount} data
			</Typography>
			<Pagination
				count={pageCount}
				page={currentPage + 1}
				className="p-[-8px]"
				onChange={handlePageChange}
				renderItem={(item) => (
					<PaginationItem
						size="large"
						components={{
							previous: (props) => (
								<ArrowBackIcon fontSize="large" className="mx-[-25px]" />
							),
							next: (props) => (
								<ArrowForwardIcon fontSize="large" className="mx-[-25px]" />
							),
						}}
						{...item}
						sx={{
							"&.Mui-selected": {
								backgroundColor: "#f2a365",
								color: "#fff",
							},
							"&.MuiPaginationItem-previousNext": {
								border: "none",
							},
							border: "1px solid #f2a365",
							borderRadius: "50%",
						}}
					/>
				)}
				siblingCount={0}
				boundaryCount={1}
				shape="rounded"
			/>
		</Box>
	);
};

export default CustomFooterComponent;
